import { graphql, Link, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"
import "./resortsMenu.scss"
import { useIntl } from "gatsby-plugin-react-intl"
import { debounce } from "../functions"
import { generateUrlByLocale } from "../../services/intl.service"
import HTMLReactParser from "html-react-parser"
import { HOTEL_TAXONOMY_VERANDA_RESORTS_ID } from "../../constants"

const ResortsMenu = ({ resortItems, locale, hotelId, hotelName }) => {
  const intl = useIntl()

  const resortMenuFn = () => {
    const btn = document.querySelector(".resort-menu-link")
    const parentBlk = document.querySelector(".resorts-submenu")
    btn.classList.toggle("show")
    parentBlk.classList.toggle("show")
  }

  let menuTitle;

  // Get footer data by locale
  switch (locale) {
    case "fr":
      menuTitle = "Nos Hôtels"
      break
    default:
      menuTitle = "Our Hotels"
  }

  if (typeof hotelId === "undefined") {
    hotelId = HOTEL_TAXONOMY_VERANDA_RESORTS_ID
  }

  return (
    <span className="resorts-header resorts-menu">
      <button className="resort-menu-link" onClick={resortMenuFn}>
        {menuTitle}
      </button>
      <span className="resorts-submenu notranslate" onMouseLeave={resortMenuFn}>
        <ul>
          {hotelId !== HOTEL_TAXONOMY_VERANDA_RESORTS_ID && (
            <li className="firstLi">
              <Link to={intl.locale === "en" ? "/en" : "/"}>
                Veranda Resorts
              </Link>
            </li>
          )}
          {resortItems.map(resort => (
            resort.title !== hotelName && (
              <li key={resort.id}>
                <Link
                  to={resort.link.url}
                >
                  {HTMLReactParser(
                    resort.title
                      .toString()
                      .replace(/-/g, " ")
                  )}
                </Link>
              </li>
            )
          ))}
        </ul>
      </span>
    </span>
  )
}

export default ResortsMenu
